import { Widget, WidgetSettingType } from '../base/widget/WidgetInterface'
import { WidgetHeightType, WidgetType } from '../base/widget/WidgetTypes'

export const WidgetStatusCompact: Widget = {
  type: WidgetType.statusCompact,
  noPadding: true,
  title: 'Kompaktansicht',
  minSize: 2,
  defaultSize: 8,
  icon: 'Apps',
  defaultHeightType: WidgetHeightType.automatic,
  customSettings: {
    settings: {
      showStatusNames: { type: WidgetSettingType.checkbox, title: 'Statusnamen anzeigen', checked: false },
      showTotalAvailability: { type: WidgetSettingType.checkbox, title: 'Vollständige Verfügbarkeit anzeigen', checked: true },

      fontSizeStatusNames: { type: WidgetSettingType.number, title: 'Statusnamen', value: 18, min: 14, max: 128 },
      fontSizeTotalAvailability: { type: WidgetSettingType.number, title: 'Vollständige Verfügbarkeit', value: 48, min: 14, max: 128 },
      fontSizeQualificationsShortname: { type: WidgetSettingType.number, title: 'Qualifikationen (Kürzel)', value: 14, min: 14, max: 128 },
      fontSizeQualificationsCount: { type: WidgetSettingType.number, title: 'Qualifikationen (Anzahl)', value: 14, min: 14, max: 128 },

      sortQualifications: { type: WidgetSettingType.custom, data: {}, template: 'custom/SettingsPanelCustomCustomQualificationsSorting' },
      sortStatus: { type: WidgetSettingType.custom, data: {}, template: 'custom/SettingsPanelCustomCustomStatusSorting' }
    },
    sections: [
      {
        label: 'Schriftgrößen',
        settings: [
          'fontSizeStatusNames',
          'fontSizeTotalAvailability',
          'fontSizeQualificationsShortname',
          'fontSizeQualificationsCount'
        ]
      },
      {
        label: 'Filter (sortierbar)',
        settings: [
          'sortStatus',
          'sortQualifications'
        ]
      }
    ]
  }
}

export default WidgetStatusCompact
